/**
 * PII isaretli property degerleri tarayicida hash'lenir; ham deger sunucuya gitmez.
 * Tuz olarak siteId kullanilir, boylece ayni e-posta farkli sitelerde ayni hash'i uretmez.
 * SubtleCrypto yoksa (eski tarayici / http) property dusurulur.
 */

function toHex(buffer) {
    const bytes = new Uint8Array(buffer);
    let hex = "";
    for (let i = 0; i < bytes.length; i++) {
        hex += (bytes[i] + 0x100).toString(16).slice(1);
    }
    return hex;
}

function isAvailable() {
    return !!(window.crypto && window.crypto.subtle && typeof TextEncoder === "function");
}

/**
 * @param {String} siteId tuz
 * @param {*} value hash'lenecek deger
 * @returns {Promise<String|null>} hex SHA-256; hesaplanamazsa null
 */
export function hashValue(siteId, value) {
    if (value === null || value === undefined || value === "") return Promise.resolve(null);
    if (!isAvailable()) return Promise.resolve(null);

    const normalized = String(siteId) + ":" + String(value).trim().toLowerCase();
    try {
        const data = new TextEncoder().encode(normalized);
        return window.crypto.subtle
            .digest("SHA-256", data)
            .then(toHex)
            .catch(function () {
                return null;
            });
    } catch (e) {
        return Promise.resolve(null);
    }
}

export default hashValue;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/rules/hash.js
// module id = null
// module chunks = 